import { CategoryField } from "./category-field.model";
import { Category } from "./category.model";
import { DataType } from "./data-type.model";
import { FieldType } from "./field-type.model";
import { FieldValidation } from "./field-validation.model";
import { FixedFunction } from "./fixed-function.model";

export class FieldConfig {
    public fieldConfigId: number;
    public name: string;
    public code: string;
    public type: FieldType;
    public dataType: DataType;
    public formula: string;
    public mergeField: string;
    public hide: boolean;
    public categoryField: CategoryField;
    public children: Array<FieldConfig>;
    public defaultValue: string;
    public multiple: boolean;
    public endGroup: string;
    public group: boolean;
    public startGroup: string;
    public orderNo: number;
    public relatedFieldCode: string;
    public relatedFieldDataCode: string;
    public fixedFieldCode: string;
    public fixedFunction: FixedFunction;
    public refCategoryField: CategoryField;
    public validations: Array<FieldValidation>;
    public category: Category;
    public note: string;
    public parentId: number;

    public templateFieldConfigId: number;
    public editorSignatureId?: number;
    public editorSignatureIdPresent?: boolean;

    public static build(): FieldConfig {
        const fieldConfig: FieldConfig = new FieldConfig();
        fieldConfig.fieldConfigId = null;
        fieldConfig.name = null;
        fieldConfig.code = null;
        fieldConfig.type = null;
        fieldConfig.dataType = null;
        fieldConfig.formula = null;
        fieldConfig.mergeField = null;
        fieldConfig.hide = null;
        fieldConfig.categoryField = null;
        fieldConfig.children = null;
        fieldConfig.defaultValue = null;
        fieldConfig.multiple = null;
        fieldConfig.endGroup = null;
        fieldConfig.group = null;
        fieldConfig.startGroup = null;
        fieldConfig.orderNo = null;
        fieldConfig.relatedFieldCode = null;
        fieldConfig.relatedFieldDataCode = null;
        fieldConfig.fixedFieldCode = null;
        fieldConfig.fixedFunction = null;
        fieldConfig.refCategoryField = null;
        fieldConfig.validations = [];
        fieldConfig.category = null;
        fieldConfig.note = null;
        fieldConfig.parentId = null;
        fieldConfig.editorSignatureId = null;
        return fieldConfig;
    }
}
